import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ClientsListView from './Clients';
import ClientDetailView from './ClientDetail';
import AvalDetailView from './AvalDetail';
import TransactionDetailView from './TransactionDetail';

const ClientsView = () => (
  <Routes>
    <Route
      path="detail/:id/aval/detail/:avalId/*"
      element={<AvalDetailView />}
    />
    <Route path="detail/:id/aval/detail/:avalId" element={<AvalDetailView />} />
    <Route
      path="transactions/:transactionId"
      element={<TransactionDetailView />}
    />
    <Route path="detail/:id/:tab/*" element={<ClientDetailView />} />
    <Route path="detail/:id/:tab" element={<ClientDetailView />} />
    <Route path="detail/:id" element={<ClientDetailView />} />
    <Route path="list" element={<Navigate to="" replace />} />
    <Route path=":tab" element={<ClientsListView />} />
    <Route index element={<ClientsListView />} />
  </Routes>
);

export default ClientsView;
